import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import HintOverlay from "./components/header/HintOverlay";

// Components
import Intro from "./components/intro/imgText2Button";
import ChatBox from "./components/chat/chat";
import Place from "./components/place/place";
import LoginName from "./components/login/loginOne";
import Tutorial from "./components/tutorial/tutorial";
import Quize from "./components/quize/quize";
import Wrong from "./components/wrong/wrong";
import Keyword from "./components/keywordInput/keyword";
import Answer from "./components/answer/answer";
import Clear from "./components/clear/clear";
import Survey from "./components/survey/survey";
import Ranking from "./components/ranking/ranking";

import Adm from "./components/adm/index";

import PersonComponent from "./PersonComponent.js";

import ScrollTotop from "./scrollToTop";
import "./index.css";

// IMG import
import tutorial1 from "./img/tutorial/tutorial-1.png";
import tutorial2 from "./img/tutorial/tutorial-2.png";
import tutorial3 from "./img/tutorial/tutorial-3.png";
import HintContainer from "./components/header/HintContainer.js";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // Intro 입력값 로컬 state
  // (Intro 내부에서 useGame()으로 Context에도 저장하므로 여기선 UI용으로만 사용)
  const [introTeam, setIntroTeam] = useState("");
  const [introInCode, setIntroInCode] = useState("");

  // LoginName 입력값 로컬 state
  const [nameText, setNameText] = useState("");

  const handleFinish = ({ route, defaultPath, state }) => {
    navigate(route || defaultPath, { state });
  };

  return (
    <>
      <ScrollTotop />
      <HintOverlay />
      <Routes>
        {/* <Route path="/" element={<PersonComponent />} /> */}
        <Route
          path="/"
          element={
            <Intro
              handleName={introTeam}
              setHandleName={setIntroTeam}
              handleName2={introInCode}
              setHandleName2={setIntroInCode}
              onFinish={handleFinish}
              defaultPath="/login"
            />
          }
        />
        <Route
          path="/login"
          element={
            <LoginName
              handleName={nameText}
              setHandleName={setNameText}
              onFinish={handleFinish}
              defaultPath="/story"
            />
          }
        />
        <Route
          path="/story"
          element={
            <ChatBox
              DateVal={"DATA1"}
              titImgClass={"infoTit"}
              onFinish={handleFinish}
              defaultPath="/tutorial"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/tutorial"
          element={
            <Tutorial
              tutorialImgs={[tutorial1, tutorial2, tutorial3]}
              onFinish={handleFinish}
              defaultPath="/story2"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/story2"
          element={
            <ChatBox
              DateVal={"DATA2"}
              titImgClass={"infoTit2"}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/keywordInput"
          element={
            <Keyword
              answerData={"keyword"}
              DateVal={"DATA3"}
              titImgclassName={"infoTit"}
              hintWhetherIs={false}
              hintContent={""}
              timerMode="run"
            />
          }
        />
        <Route
          path="/info"
          element={
            <ChatBox
              key={location.key}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="run"
            />
          }
        />
        <Route
          path="/place"
          element={
            <Place
              key={location.key}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="run"
            />
          }
        />
        <Route path="/hint" element={<HintContainer />} />
        <Route path="/quiz" element={<Quize key={location.key} />} />
        <Route path="/wrong" element={<Wrong />} />
        <Route
          path="/answer"
          element={<Answer DateVal={"DATA2"} titImgclassName={"infoTit"} />}
        />
        <Route path="/clear" element={<Clear />} timerMode="pause" />

        <Route path="/ranking" element={<Ranking />} />
        <Route path="/survey/:step" element={<Survey />} timerMode="pause" />

        {/* 관리자 */}
        <Route path="/adm" element={<Adm />} />
        {/* 관리자 END */}
      </Routes>
    </>
  );
}
